// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatDateFromApi = (date, options = {}, locale) => {
  if (date) {
    const objectDate = new Date(date);
    return {
      raw: objectDate,
      string: objectDate.toLocaleDateString(locale, options),
    };
  }
  return null;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getFormatedDates = (param, options = {}, locale) => {
  if (param == null) {
    // eslint-disable-next-line no-console
    console.warn('Given date to format is null or undefined');
    return null;
  }
  if (typeof param === 'string') {
    return formatDateFromApi(param, options, locale);
  }
  if (Array.isArray(param)) {
    return param.map((date) => getFormatedDates(date, options, locale));
  }
  if (typeof param === 'object') {
    return Object.keys(param).reduce((acc, curr) => {
      acc[curr] = getFormatedDates(param[curr], options, locale);
      return acc;
    }, {});
  }
  // eslint-disable-next-line no-console
  console.warn('Given param', param, 'cannot be reduced to a date type');
  return null;
};

/**
 * Compares a date to now and returns the number value that represents
 * the result:
 * 0 if date is now.
 * 1 if the date is greater or equal than now.
 * -1 if the date is less or equal than now.
 * @param date Date object to compare.
 */
export const compareDateToNow = (date) => {
  // With Date object we can compare dates them using the >, <, <= or >=.
  // The ==, !=, ===, and !== operators require to use date.getTime(),
  // so we need to create a new instance of Date with 'new Date()'
  const d1 = new Date(date);
  const now = new Date();
  let res = 0;

  if (d1 >= now) {
    res = 1;
  }
  if (d1 <= now) {
    res = -1;
  }

  return res;
};

export const getIsDistributable = (startDiffusionDate, endDiffusionDate) => {
  const areWeAfterStartDiffusionDate =
    compareDateToNow(startDiffusionDate) !== 1;
  const areWeBeforeEndDiffusionDate =
    !endDiffusionDate || compareDateToNow(endDiffusionDate) !== -1;

  return areWeAfterStartDiffusionDate && areWeBeforeEndDiffusionDate;
};
